import layoutStore from './layout.store';
import sessionStore from './session.store';
import dictionariesStore from './dictionaries.store';
import projectsStore from './projects.store';
import studentsStore from './students.store';

export default {
    layoutStore,
    sessionStore,
    dictionariesStore,
    projectsStore,
    studentsStore
};